export const entityType = Object.freeze({
  original: 'Original',
  demo: 'Demo',
});
